import * as CONST from "./actionTypes";

const intialState = {
  agencyListData: [],
  agencyDataById: null,
  total: 0,
  loading: false,
};

const agencyReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    //get data
    case CONST.GET_AGENCIES:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_AGENCIES_SUCCESS:
      return {
        ...state,
        agencyListData: payload?.data,
        total: payload.totalcount,
        loading: false,
      };

    case CONST.GET_AGENCIES_FAIL:
      return {
        ...state,
        loading: false,
      };

    case CONST.UPDATE_AGENCIES_DATA:
      return {
        ...state,
        agencyListData: payload,
      };
    // get service by id

    case CONST.GET_AGENCY_VIEW:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_AGENCY_VIEW_SUCCESS:
      return {
        ...state,
        agencyDataById: payload,
        loading: false,
      };

    case CONST.GET_AGENCY_VIEW_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;

      break;
  }
};

export default agencyReducer;
